module.exports = __webpack_public_path__ + "img/txt-title.12f96464.jpg";